import { useId } from "react";
import { useTranslation } from "react-i18next";

import { orderLineHookLabel } from "@/features/marketplace/lib/order-line-hooks";

import type { PartnerHookSlot } from "../lib/partner-script-production";
import { PartnerHookSlotFields } from "./PartnerHookSlotFields";
import { PartnerHookSlotHeader } from "./PartnerHookSlotHeader";

export function PartnerScriptHookList({
  slots,
  title,
}: {
  slots: PartnerHookSlot[];
  title?: string | null;
}) {
  const { t } = useTranslation();
  const headingId = useId();

  return (
    <section aria-labelledby={headingId} className="flex flex-col gap-2">
      <div className="flex items-baseline justify-between gap-3">
        <h3
          id={headingId}
          className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground"
        >
          {t("marketplace.partner.workspace.hooks", "Scene 1 hooks")}
        </h3>
        <span className="text-xs tabular-nums text-muted-foreground">
          {t("marketplace.partner.workspace.hookCount", {
            count: slots.length,
            defaultValue_one: "{{count}} hook",
            defaultValue_other: "{{count}} hooks",
          })}
        </span>
      </div>
      <ul
        aria-labelledby={headingId}
        className="divide-y divide-border-subtle rounded-sm border border-border"
      >
        {slots.map((slot) => (
          <li key={slot.hookKey ?? `hook-${slot.index}`} className="flex flex-col gap-2 px-4 py-3">
            <PartnerHookSlotHeader
              slot={slot}
              label={orderLineHookLabel(t, slot)}
              title={title ?? ""}
              headingAs="h4"
            />
            <PartnerHookSlotFields slot={slot} />
          </li>
        ))}
      </ul>
    </section>
  );
}
